import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import queryString from "query-string";

// ScrollToTop component
function ScrollToTop() {
  const location = useLocation();
  
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    
    scrollToTop();
    
    // Add scroll event listener
    window.addEventListener('beforeunload', scrollToTop);
    
    // Cleanup
    return () => {
      window.removeEventListener('beforeunload', scrollToTop);
    };
  }, [location.pathname]);
  
  return null;
}

// Export ScrollToTop component
export { ScrollToTop };

// Custom hook for routing
export function useRouter() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();

  return {
    pathname: location.pathname,
    query: {
      ...queryString.parse(location.search),
      ...params,
    },
    location,
    navigate,
    params,
  };
}